export default function toInputString(val: any): string {
    // eslint-disable-next-line eqeqeq
    return val != null ? "" + val : "";
}

export function toInputObject(val: any): string {
    // eslint-disable-next-line eqeqeq
    return val != null ? val : {};
}
